// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__3bY74","welcomeSegment":"StartPage_welcomeSegment__3ptlF","companyLogoSegment":"StartPage_companyLogoSegment__3sxQF"};